var _circle, _g, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconeOdonto = function SvgIconeOdonto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#FF8C54"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_14652_31399)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#FFECE8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14652_31399)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_14652_31399)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7778 14.7777C11.7778 14.7777 12.3488 17.4444 12.2223 18.7777C11.9603 21.5389 11.339 25.7304 13.4246 25.7304C14.8889 25.7304 13.9999 22.3333 17.9999 19.2222C21.9999 21 18.319 24.9949 20.1473 25.7304C21.7317 26.3678 23.4019 24.2455 23.7777 21.5544C24.1535 18.8633 23.9944 16.427 24.6667 15.2222C25.339 14.0174 11.7778 14.7777 11.7778 14.7777Z",
    fill: "#FFECE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0804 15.0119C12.1619 15.0077 12.2595 15.0027 12.3717 14.9971C12.7406 14.9787 13.267 14.9537 13.8967 14.9275C15.1562 14.8751 16.8276 14.8178 18.4774 14.7981C20.1292 14.7784 21.7514 14.7965 22.9157 14.8936C23.5017 14.9425 23.9533 15.01 24.2323 15.0961C24.3191 15.1228 24.3765 15.1477 24.4125 15.1672C24.0732 15.8219 23.9494 16.7587 23.8619 17.8102C23.8359 18.1224 23.813 18.4469 23.7894 18.7818C23.7292 19.6367 23.6642 20.5595 23.5301 21.5198C23.3473 22.8287 22.8508 23.9853 22.2244 24.7296C21.594 25.4787 20.8875 25.7587 20.2406 25.4985C20.0685 25.4293 19.9764 25.3309 19.9222 25.2102C19.8635 25.0792 19.8407 24.9016 19.8526 24.6658C19.8644 24.4314 19.9088 24.1638 19.9649 23.8625C19.9768 23.7981 19.9894 23.7323 20.0021 23.6652C20.0481 23.4234 20.0971 23.1652 20.1354 22.9033C20.2331 22.2342 20.2687 21.4927 19.999 20.7955C19.725 20.087 19.1505 19.46 18.1014 18.9937C18.0172 18.9563 17.9192 18.9682 17.8464 19.0248C15.798 20.618 14.9979 22.2905 14.5271 23.5558C14.4474 23.7699 14.3762 23.9749 14.3111 24.1628C14.2813 24.2484 14.2529 24.3304 14.2254 24.4081C14.1358 24.6614 14.0563 24.8704 13.9715 25.0385C13.8866 25.207 13.8052 25.3161 13.7214 25.3832C13.6441 25.445 13.5536 25.4804 13.4246 25.4804C13.2081 25.4804 13.0384 25.4268 12.901 25.3362C12.7617 25.2444 12.6417 25.1055 12.541 24.9153C12.336 24.5282 12.2285 23.9623 12.1928 23.2765C12.1337 22.1438 12.2723 20.7776 12.3969 19.5492C12.4229 19.2928 12.4483 19.0424 12.4712 18.8013C12.5377 18.1003 12.4214 17.0722 12.2946 16.2401C12.2306 15.8196 12.1626 15.4415 12.1107 15.1685C12.0998 15.1116 12.0897 15.0592 12.0804 15.0119Z",
    stroke: "#FF8C54",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2222 17.0002C12.2222 17.0002 9.83159 12.9411 11.4632 10.2371C13.0947 7.5331 14.7039 8.20408 16.5742 8.60212C18.4445 9.00016 21.2798 7.25146 23.9631 8.60212C26.6464 9.95278 26.0343 11.9411 25.6728 13.4562C25.3113 14.9713 24.5778 16.6745 24.1334 17.1189C23.3334 18.3335 21.1974 16.5678 18.4445 16.5557C15.4719 16.5426 12.6667 18.3335 12.2222 17.0002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5554 10.0323C21.2728 10.0744 19.393 10.3686 18 10.3333C16.9161 10.3059 15.5921 10.1649 15.2405 10.0269C14.889 9.88889 14.6452 10.1615 15.0293 10.4933C15.626 11.0087 16.665 11.6667 18.0808 11.6667C19.4967 11.6667 20.8049 11.0087 21.6124 10.4933C21.9017 10.3086 21.838 9.99031 21.5554 10.0323Z",
    fill: "#FFC8B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14652_31399",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.54902 0 0 0 0 0.329412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31399"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31399",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14652_31399",
    x: 9.89331,
    y: 7.08105,
    width: 17.1067,
    height: 19.7634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.666667 0 0 0 0 0.513726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31399"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31399",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_14652_31399",
    x: 10.7778,
    y: 13.541,
    width: 14.9131,
    height: 13.3034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.54902 0 0 0 0 0.329412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31399"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31399",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeOdonto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-odonto.96efc1c9.svg";
export { ForwardRef as ReactComponent };